import { render, staticRenderFns } from "./LightBanner.vue?vue&type=template&id=b9b398d2&scoped=true&"
import script from "./LightBanner.vue?vue&type=script&lang=js&"
export * from "./LightBanner.vue?vue&type=script&lang=js&"
import style0 from "./LightBanner.vue?vue&type=style&index=0&id=b9b398d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b398d2",
  null
  
)

export default component.exports